import { Util } from 'src/shared/util/util';
import { isCounterpartyMessage } from 'src/shared/util/message-sender';
import { TidyStorage } from './../../shared/providers/tidy-storage';
import { Pros } from './../../providers/pros/pros';
import {
  Component,
  ElementRef,
  HostListener,
  ViewChild,
  ViewEncapsulation,
  OnInit,
  AfterViewChecked,
  DestroyRef,
  inject, OnDestroy,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ModalController } from '@ionic/angular';
import { DateTime as LuxonDateTime } from 'luxon';
import { UntypedFormGroup, FormBuilder, Validators } from '@angular/forms';
import { Client } from 'src/providers/client/client';
import { Communication, AttachmentPreview } from 'src/providers/communication/communication';
import { CurrentAddress } from 'src/providers/addresses/current-address';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { WindowService } from 'src/shared/providers/window.service';
import { Loading } from 'src/shared/components/loading/loading';
import { TimeoutableComponent } from 'src/shared/components/timeoutable/timeoutable.component';
import { scrollContentWidth } from 'src/shared/components/scroll-wrapper/scroll-wrapper.component';
import { MessageThreadPage } from './message-thread/message-thread';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { AddProxyNumberComponent } from './add-proxy-number/add-proxy-number';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlattener, MatTreeFlatDataSource } from '@angular/material/tree';
import { ItemNode, FlatNode, ChipFilter } from 'src/models/schedule.model';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { OnboardingDummyDataService } from 'src/shared/services/onboarding-dummy-data.service';
import { AboutThisPageService } from 'src/providers/about-this-page/about-this-page.service';
import { ParseDateTimePipe } from 'src/shared/pipes/parse-date.pipe';
import { interval, lastValueFrom } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { filter, debounceTime, take } from 'rxjs/operators';
import { TeamService } from 'src/providers/team/team';

import { NewMessagePage } from '../new-message/new-message';
import { EnableAutopilotComponent } from 'src/pages/go-live/enable-autopilot/enable-autopilot.component';
import { Me } from 'src/providers/me/me';
import { ConciergeApiService } from 'src/shared/services/concierge-api.service';
import { SubscriptionsQueriesService } from 'src/shared/services/subscriptions-queries.service';
import { TranslationPipe } from 'src/shared/pipes/translation.pipe';
import { DemoBlockService } from 'src/shared/services/demo-block.service';
import { MessagesHandoff, MessagesHandoffService } from 'src/shared/services/messages-handoff.service';
import type { CustomerGuest } from 'src/models/customer-guest.model';
import { EditGuestPage } from 'src/pages/customer-guests/edit-guest/edit-guest';
import { AddProPage } from 'src/pages/my-pros/add-pro/add-pro';
import { MyProPage } from 'src/pages/my-pros/my-pro/my-pro';
import { CustomerGuestsApiService } from 'src/shared/services/customer-guests-api.service';

@Component({
    templateUrl: 'messages.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./messages.scss'],
    standalone: false
})
export class MessagesPage extends TimeoutableComponent implements OnInit, AfterViewChecked, OnDestroy {
  private destroyRef = inject(DestroyRef);
  private messagesHandoff = inject(MessagesHandoffService);

  address: any;
  desktopWidthContent: string = scrollContentWidth.LARGE;
  addressId: any;
  addressFilter: any;
  addressResponse: any;
  clientName: string | null;
  errorMessage: string;
  messages: any[];
  shownMessages: any[];
  imutableMessages: any[] = [];
  form: UntypedFormGroup;
  allPros: any[];
  proList = [];
  showLoadingSpinner: boolean;
  selectedAddresses: number[];
  selectedPros: number[];
  searchForm: UntypedFormGroup;
  dateRangeForm: UntypedFormGroup;
  selectOptions: any;
  private refreshTimerSubscription: any;
  guestNumber: string = localStorage.getItem('cachedGuestNumber') || '';
  proNumber: string = localStorage.getItem('cachedProNumber') || '';
  filters: any = {};
  showDesktopHamburgerMenu: boolean;
  showExpandedDesktopHamburger: boolean;
  proxyPros: any[];
  isFiltersLoaded: boolean;
  totalMessages: string;
  pageNumber = 1;

  isAddressesLoaded = false;
  isMessagesLoaded = false;
  isProxyNumbersLoaded = false;
  isSMSForwardingLoaded = false;
  headers = ['Thread', 'Last Message', 'Sent', 'last-column'];
  wasTableLoaded: boolean;
  selectedFilters: {
    pro: any[];
    propertyName: any[];
  } = {
    pro: [],
    propertyName: []
  };
  selectedMessageType = 'all';
  private _transformer = (node: ItemNode, level: number) => ({
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level,
      data: node,
    });
  treeControl = new FlatTreeControl<FlatNode>(
    (node) => node.level,
    (node) => node.expandable
  );
  treeFlattener = new MatTreeFlattener(
    this._transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.children
  );
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  chips: ChipFilter[] = [];
  filterNamesReferences = {
    'Person': 'pro',
    'Property': 'propertyName'
  };
  hasProperties: boolean;
  showSMSForwardingEnabled = !!localStorage.getItem('cachedSmsForwardingText');
  @ViewChild('tidyTable') tidyTable: any;
  smsForwardingText: any = JSON.parse(localStorage.getItem('cachedSmsForwardingText') || 'null');
  showRightSectionButtons: boolean;
  selectedConversation: any;
  threadMessages: any[] = [];
  isThreadLoaded = false;
  isSendingThreadMessage = false;
  threadAttachmentPreviews: AttachmentPreview[] = [];
  threadMessageForm: UntypedFormGroup;
  threadPro: any;
  private threadRefreshSubscription: any;
  temporaryConversations: any[] = [];
  @ViewChild('chatMessagesContainer') chatMessagesContainer: any;
  @ViewChild('threadMessageInput') threadMessageInput: any;
  boundSendThreadMessage = this.sendThreadMessage.bind(this);
  boundSendThreadAttachment = this.sendThreadAttachment.bind(this);
  private shouldScrollToBottom = false;
  showNewMessageDropdown = false;
  isLoadingMoreThreadMessages = false;
  threadPageNumber = 1;
  totalThreadMessages = 0;
  assignedToId: number | null = null;
  assignList: any[] = [];
  isGuestNumber = false;
  // Names for guests assigned to proxy numbers are not in the latest-messages
  // payload, so resolve them lazily by id and cache for display.
  private guestNameCache = new Map<number, string>();
  private guestIds = new Set<number>();
  private guestsLoaded = false;
  private guestsLoading = false;
  originalAssignedToId: number | null = null;
  showAssignDropdown = false;
  showAboutThisPage: boolean;

  activeFeedbackMessageId: number | null = null;
  closingFeedbackMessageId: number | null = null;
  activeFeedbackType: 'positive' | 'negative' = 'positive';
  isSubmittingFeedback = false;

  // First-load skeleton scaffolding: deterministic per-item data so the
  // placeholder list/thread reads like real conversations (varied widths
  // and sender sides) instead of uniform grey blocks.
  readonly skeletonConversations = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  readonly skeletonThreadBubbles: { side: 'other' | 'user'; last: boolean }[] = [
    { side: 'other', last: false },
    { side: 'other', last: true },
    { side: 'user', last: true },
    { side: 'other', last: true },
    { side: 'user', last: false },
    { side: 'user', last: true },
    { side: 'other', last: false },
    { side: 'other', last: true },
    { side: 'user', last: true },
  ];

  @HostListener('window:resize', ['$event'])
  async onResize(event) {
    this.showDesktopHamburgerMenu = event.target.innerWidth < 1723;
    this.showRightSectionButtons = event.target.innerWidth > 1124;
  }

  constructor(
    private client: Client,
    public communication: Communication,
    public currentAddress: CurrentAddress,
    private fb: FormBuilder,
    private modalCtrl: ModalController,
    private navCtrl: CustomNavController,
    private onboardingDummyDataService: OnboardingDummyDataService,
    private pros: Pros,
    private rightSidePanelService: RightSidePanelService,
    private router: Router,
    private storage: TidyStorage,
    private teamService: TeamService,
    private util: Util,
    public windowService: WindowService,
    private aboutThisPageService: AboutThisPageService,
    private conciergeApi: ConciergeApiService,
    private me: Me,
    private subscriptionsQueries: SubscriptionsQueriesService,
    private el: ElementRef,
    private demoBlock: DemoBlockService,
    private guestsApi: CustomerGuestsApiService
  ) {
    super();
    this.showAboutThisPage = this.aboutThisPageService.checkIfShouldShowAboutThisPage('messages');
  }

  async ngOnInit() {
    try {
      await this.clearNavigationStorage();

      this.form = this.fb.group({
        selectedPro: ['', Validators.required],
        selectedAddress: ['', Validators.required],
      });
      this.searchForm = this.fb.group({
        search: [''],
      });
      this.searchForm.valueChanges
        .pipe(debounceTime(300), takeUntilDestroyed(this.destroyRef))
        .subscribe((val) => this.updateSearch(val));
      this.dateRangeForm = this.fb.group({
        start: '',
        end: '',
        customStringSelect: '',
      });
      this.threadMessageForm = this.fb.group({
        message: [''],
      });
      this.selectOptions = [
        { viewValue: new TranslationPipe().transform('Custom'), value: 'custom' },
        { viewValue: new TranslationPipe().transform('Today'), value: 'today' },
        { viewValue: new TranslationPipe().transform('Last Week'), value: 'last_week' },
        { viewValue: new TranslationPipe().transform('Last Month'), value: 'last_month' },
        { viewValue: new TranslationPipe().transform('All Time'), value: 'all_time' },
      ];
      await this.loadPage();
      await this.watchMessageUpdates();
      this.startUnifiedRefreshTimer();
      this.handleRouterEvents();
    } catch (err) {
      this.errorMessage = err?.error?.message ?? err?.message;
    }
  }

  ngAfterViewChecked(): void {
    if (this.shouldScrollToBottom && this.chatMessagesContainer?.nativeElement) {
      this.scrollThreadToBottom();
      this.shouldScrollToBottom = false;
    }
  }

  onAboutThisPageDismissed() {
    // Handler for when about-this-page overlay is dismissed
  }

  handleRouterEvents() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((event: NavigationEnd) => {
      if (!event.url.includes('/messages')) {
        this.refreshTimerSubscription?.unsubscribe();
        this.refreshTimerSubscription = null;
        this.threadRefreshSubscription?.unsubscribe();
        this.threadRefreshSubscription = null;
      } else {
        if (!this.refreshTimerSubscription) {
          this.startUnifiedRefreshTimer();
        }
      }
    });
  }

  startUnifiedRefreshTimer(): void {
    this.refreshTimerSubscription?.unsubscribe();
    this.threadRefreshSubscription?.unsubscribe();
    this.refreshTimerSubscription = interval(10000).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.refreshAllMessages();
    });
  }

  async refreshAllMessages(): Promise<void> {
    const promises: Promise<any>[] = [];
    if (this.filters && Object.keys(this.filters).length !== 0) {
      promises.push(this.loadMessages(this.filters).then(() => this.filterRows()));
    } else {
      promises.push(this.loadMessages().then(() => this.filterRows()));
    }
    if (this.selectedConversation) {
      promises.push(this.refreshThreadMessagesOnly());
    }
    await Promise.all(promises);
  }

  async refreshMessages() {
    if (this.filters && Object.keys(this.filters).length !== 0) {
      await this.loadMessages(this.filters);
      this.filterRows();
    } else {
      await this.loadMessages();
      this.filterRows();
    }
  }

  async refreshThreadMessagesOnly(): Promise<void> {
    if (!this.selectedConversation) {
      return;
    }
    try {
      let messagesResponse: { body: any[]; totalRecords: string };
      if (this.selectedConversation.chatRoom.type === 'proxy' || !this.threadPro?.main_team_id) {
        messagesResponse = await this.communication.getProxySharedInbox(this.selectedConversation.chatRoom.key, this.pageNumber, 20, true);
      } else {
        messagesResponse = await this.communication.getSharedInbox(this.threadPro.main_team_id, this.pageNumber, 20);
      }
      if (messagesResponse?.body) {
        const previousCount = this.threadMessages.filter(m => m.type !== 'chat_suggestion').length;
        const messages = [...messagesResponse.body, ...this.threadMessages];
        this.threadMessages = this.deduplicateThreadMessages(messages);
        this.totalMessages = messagesResponse.totalRecords;
        const newCount = this.threadMessages.filter(m => m.type !== 'chat_suggestion').length;
        if (newCount > previousCount) {
          setTimeout(() => this.scrollThreadToBottom(), 100);
          this.markThreadMessagesAsRead(this.selectedConversation);
        }
      }
    } catch (_err) {
      // Silent error - refresh failure is not critical
    }
  }

  async loadPage(showLoadingSpinner = false, setStoredRoute = true) {
    this.showAboutThisPage = this.aboutThisPageService.checkIfShouldShowAboutThisPage('messages');
    // Desktop keeps this page alive between visits, so it comes back showing the
    // last conversation. A handoff from another page must replace it before any
    // await here, or the host sees (and types to) the wrong person until it does.
    const canOpenHandoff = this.windowService.isDesktopRes && !this.showAboutThisPage;
    const earlyHandoff = canOpenHandoff && this.wasTableLoaded ? this.openStoredConversationHandoff() : null;
    if (showLoadingSpinner) {
      this.showLoadingSpinner = true;
    }
    await this.storage.delete('proId');
    await this.storage.delete('chatRoomKey');
    this.loadCriticalUIElements();
    this.resetLoadingStates();
    this.errorMessage = '';
    const loadingPromises = this.startIndependentDataLoading();
    const openedHandoffEarly = earlyHandoff ? await earlyHandoff : false;
    await Promise.all(loadingPromises.map(promise =>
      promise.catch(_error => null)
    ));
    this.refreshDisplayNames();
    this.wasTableLoaded = true;
    if (this.windowService.isDesktopRes && setStoredRoute) {
      this.storage.setStoredRoute('/messages').then(async () => {
        await this.loadPage(true);
      });
    }
    if (openedHandoffEarly) {
      this.reselectSelectedConversation();
      return;
    }
    if (canOpenHandoff && await this.openStoredConversationHandoff()) {
      return;
    }
    if (this.windowService.isDesktopRes && !this.selectedConversation) {
      if (this.showAboutThisPage) {
        if (this.shownMessages?.length > 0) {
          this.selectedConversation = this.shownMessages[0];
          this.loadMockThreadMessages();
        }
      } else if (this.shownMessages?.length) {
        await this.goToMessagesPage(this.shownMessages[0]);
      }
    }
  }

  // An in-memory handoff (the Schedule's Message) opens with no await before the
  // switch; the stored one is the New Message panel's.
  async openStoredConversationHandoff(): Promise<boolean> {
    const handoff = this.messagesHandoff.take() ?? await this.takeStoredHandoff();
    if (!handoff) {
      return false;
    }
    this.clearPreviousConversationLeftovers();
    if (handoff.type === 'guest') {
      await this.createAndSelectNewGuestConversation(handoff.guest);
      return true;
    }
    const match = [...(this.messages || []), ...(this.imutableMessages || [])].find(
      (m: any) => m?.chatRoom?.key === handoff.chatRoomKey
        || m?.homekeeper?.chat_room_key === handoff.chatRoomKey,
    );
    await this.goToMessagesPage(match || this.buildKeyedRoomConversation(handoff.chatRoomKey, handoff.details));
    return true;
  }

  private async takeStoredHandoff(): Promise<MessagesHandoff | null> {
    const newMessageGuest = await this.storage.retrieve('newMessageGuest');
    if (newMessageGuest) {
      await this.storage.delete('newMessageGuest');
      return { type: 'guest', guest: newMessageGuest };
    }
    const autoOpenChatRoomKey = await this.storage.retrieve('autoOpenChatRoomKey');
    if (!autoOpenChatRoomKey) {
      return null;
    }
    const details = await this.storage.retrieve('autoOpenChatRoomDetails');
    await this.storage.delete('autoOpenChatRoomKey');
    await this.storage.delete('autoOpenChatRoomDetails');
    return { type: 'room', chatRoomKey: autoOpenChatRoomKey, details };
  }

  // The inbox only lists rooms with a message in the last 30 days, so an older
  // room is opened from its key alone, the way the mobile thread page does.
  private buildKeyedRoomConversation(chatRoomKey: string, details: { pageTitle?: string; chatRoom?: any } | null): any {
    const displayName = details?.pageTitle || 'Guest';
    const isSmsRoom = chatRoomKey.split(',').some((segment) => segment.split('-')[0].endsWith('number'));
    return {
      homekeeper: { chat_room_key: chatRoomKey, first_name: displayName },
      displayName,
      chatRoom: {
        ...(details?.chatRoom || {}),
        key: chatRoomKey,
        type: details?.chatRoom?.type || (isSmsRoom ? 'proxy' : 'guest'),
      },
      tags: [],
      message: '',
      isUnread: false,
    };
  }

  // A search or draft left over from an earlier visit belongs to the previous
  // conversation, not to the handed-off one.
  private clearPreviousConversationLeftovers(): void {
    this.threadMessageForm?.get('message')?.reset('');
    if (!this.searchForm?.value?.search) {
      return;
    }
    this.searchForm.patchValue({ search: '' }, { emitEvent: false });
    this.shownMessages = this.messages;
  }

  private loadCriticalUIElements() {
    this.showRightSectionButtons = window.innerWidth > 1124;
    this.showDesktopHamburgerMenu = window.innerWidth < 1723;
    this.showSMSForwardingEnabled = true;
    this.clientName = localStorage.getItem('customer_name');
    this.loaded = true;
  }

  private resetLoadingStates() {
    this.isAddressesLoaded = false;
    this.isMessagesLoaded = false;
    this.isProxyNumbersLoaded = false;
    this.isSMSForwardingLoaded = false;
  }

  private async clearNavigationStorage(): Promise<void> {
    await this.storage.delete('proId');
    await this.storage.delete('chatRoomKey');
    await this.storage.delete('dialog-params');
  }

  private startIndependentDataLoading(): Promise<any>[] {
    const loadingPromises: Promise<any>[] = [];
    loadingPromises.push(this.loadAddresses());
    loadingPromises.push(this.loadProxyNumbers());
    loadingPromises.push(this.loadMessages());
    loadingPromises.push(this.loadSMSForwardingText());
    loadingPromises.push(this.ensureGuestsLoaded());

    return loadingPromises;
  }

  private async loadAddresses(): Promise<void> {
    try {
      if (this.showAboutThisPage) {
        this.addressResponse = this.onboardingDummyDataService.getPropertiesMockData();
      } else {
        this.addressResponse = await this.client.getAddresses();
      }
      this.addressFilter = this.client.parseAddressList(
        this.addressResponse,
        false
      );
      this.storage.save('addressFilter', this.addressFilter);
      this.isAddressesLoaded = true;
      this.updateLoadingState();
    } catch (error) {
      this.errorMessage = error?.error?.message ?? error?.message ?? 'Failed to load addresses';
      this.isAddressesLoaded = true;
      this.updateLoadingState();
    }
  }

  private async loadProxyNumbers(): Promise<void> {
    try {
      await this.getProxyNumbers();
      this.getTreeData();
      this.isProxyNumbersLoaded = true;
      this.updateLoadingState();
    } catch (_error) {
      this.isProxyNumbersLoaded = true;
      this.updateLoadingState();
    }
  }

  private async loadSMSForwardingText(): Promise<void> {
    try {
      this.smsForwardingText = await this.teamService.getSMSForwardingText('messages');
      localStorage.setItem('cachedSmsForwardingText', JSON.stringify(this.smsForwardingText));
      this.isSMSForwardingLoaded = true;
    } catch (_error) {
      this.isSMSForwardingLoaded = true;
    }
  }

  private isAllCriticalDataLoaded(): boolean {
    return this.isAddressesLoaded && this.isMessagesLoaded && this.isProxyNumbersLoaded;
  }

  private updateLoadingState(): void {
    if (this.isAllCriticalDataLoaded()) {
      this.showLoadingSpinner = false;
    }
  }

  dismissAboutThisPage() {
    this.showAboutThisPage = false;
    this.selectedConversation = null;
    this.threadMessages = [];
    this.messages = [];
    this.shownMessages = [];
    this.imutableMessages = [];
    this.loadPage(true, false);
  }

  watchMessageUpdates() {
    this.communication.getUpdateMessages().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((update) => {
      if (update) {
        this.refreshMessages();
      }
    });
  }

  getProxyPros(proxyNumbers: any[]): any[] {
    return proxyNumbers
      .map((item) => item?.chat_rooms?.map((chatRoom) => {
          const pro = chatRoom?.all_chat_room_members?.find(
            (member) => member?.type === 'PhoneNumber'
          );
          const parsedPhoneNumber = chatRoom?.data?.phone_number?.replace(
            /^\+?\d{1,3}(\d{3})(\d{3})(\d{4})$/,
            '($1) $2-$3'
          );
          return {
            ...pro,
            chat_room_key: chatRoom?.key,
            data: chatRoom?.data,
            last_name: parsedPhoneNumber,
          };
        }))
      .flat()
      .filter((item) => item);
  }

  ngOnDestroy() {
    this.refreshTimerSubscription?.unsubscribe();
    this.threadRefreshSubscription?.unsubscribe();
    this.storage.delete('proId');
    this.storage.delete('chatRoomKey');
  }

  toggleDesktopHamburger() {
    this.showExpandedDesktopHamburger = !this.showExpandedDesktopHamburger;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const hamburgerMenu = target.closest('.desktop-hamburger');
    if (!hamburgerMenu && this.showExpandedDesktopHamburger) {
      this.showExpandedDesktopHamburger = false;
    }
    if (this.showNewMessageDropdown && !target.closest('.create-button') && !target.closest('.new-message-dropdown')) {
      this.showNewMessageDropdown = false;
    }
  }

  async getFilteredMessages(filters: any): Promise<void> {
    await this.loadMessages(filters);
    if (this.searchForm.value.search) {
      this.updateSearch({search: this.searchForm.value.search});
    }
  }

  async selectCustomDateRange(selection) {
    if (this.showAboutThisPage) {
      return;
    }
    const start = new Date(selection.start);
    const end = new Date(selection.end);
    const startDate = LuxonDateTime.fromJSDate(start).toISODate();
    const endDate = LuxonDateTime.fromJSDate(end).toISODate();
    this.filters['fromDate'] = startDate;
    this.filters['untilDate'] = endDate;
    await this.getFilteredMessages(this.filters);
    this.filterRows();
  }

  async selectStringDateRange(selection) {
    if (this.showAboutThisPage) {
      return;
    }
    const today = LuxonDateTime.local();
    let startDate = today.toISODate();
    let endDate = today.toISODate();
    if (selection === 'last_week') {
      startDate = today.minus({ days: 7 }).toISODate();
    }
    if (selection === 'last_month') {
      startDate = today.minus({ months: 1 }).toISODate();
    }
    if (selection === 'all_time') {
      startDate = null;
      endDate = null;
    }
    this.filters['fromDate'] = startDate;
    this.filters['untilDate'] = endDate;
    await this.getFilteredMessages(this.filters);
    this.filterRows();
  }

  async getProxyNumbers(): Promise<void> {
    try {
      const proxyNumbers = await this.communication.getProxyNumbers();
      this.proxyPros = this.getProxyPros(proxyNumbers);
      const pros = await this.pros.getAllPros();
      this.allPros = [...this.proxyPros, ...pros];
      this.proList = this.parseProList(this.allPros);
      this.storage.save('pros', this.allPros);
      this.storage.save('proList', this.proList);
      const rawGuestNumber = proxyNumbers?.find(
        (item) => item?.number_type === 'guest'
      )?.phone_number;
      this.guestNumber = this.getParsedProxyNumber(rawGuestNumber);
      const rawProNumber = proxyNumbers?.find(
        (item) => item?.number_type === 'homekeeper'
      )?.phone_number;
      this.proNumber = this.getParsedProxyNumber(rawProNumber);
      localStorage.setItem('cachedGuestNumber', this.guestNumber || '');
      localStorage.setItem('cachedProNumber', this.proNumber || '');
      this.isFiltersLoaded = true;
    } catch (err) {
      this.isFiltersLoaded = true;
      this.errorMessage =
        err.error && err.error.message ? err.error.message : err.message;
    }
  }

  getParsedProxyNumber(number: string): string {
    if (!number) {
      return;
    }
    return number?.replace(/^\+?\d{1,3}(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3');
  }

  updateSearch({ search }) {
    if (search.length < 2 || search === '') {
      this.shownMessages = this.messages;
      return;
    }
    const term = search.toLowerCase();
    this.shownMessages = [];
    this.messages.map((message) => {
      // Proxy room members are unnamed phone numbers, so the card's rendered name is the only searchable name.
      if (message.displayName?.toLowerCase().includes(term)) {
        this.shownMessages.push(message);
        return;
      }
      message.chatRoom.all_chat_room_members.map((chatRoom) => {
        const personIsMatch = chatRoom?.first_name?.toLowerCase().includes(term) || chatRoom?.last_name?.toLowerCase().includes(term);
        if (chatRoom.type !== 'CustomerMember' && personIsMatch && !this.shownMessages.includes(message)) {
          this.shownMessages.push(message);
        }
      });
      const isTextMatch = message.chatRoom?.last_chat_room_message?.content?.text?.toLowerCase().includes(term) ?? false;
      if (isTextMatch && !this.shownMessages.includes(message)) {
        this.shownMessages.push(message);
      }
    });
  }

  parseProList(pros: any[]): any[] {
    return pros.map((pro) => ({
      value: pro?.chat_room_key || pro?.id,
      viewValue: `${pro?.first_name  } ${  pro?.last_name}`,
      teamId: pro?.main_team_id,
      chatRoomKey: pro?.chat_room_key,
      proId: pro?.id,
    }));
  }

  getTags(chatRoom: any, job?: any, homekeeper?: any): string[] {
    const tags = [];
    const dontAddTags = ['proxy', 'account'];
    if (chatRoom?.type && !job && !dontAddTags.includes(chatRoom?.type)) {
      tags.push(chatRoom?.type?.replace('_', ' '));
    }
    if (chatRoom?.type === 'account') {
      tags.push(`${homekeeper?.first_name  } ${  homekeeper?.last_name}`);
    }
    if (chatRoom.type === 'proxy') {
      tags.push(new TranslationPipe().transform('Smart #'));

      const numberType = chatRoom?.data?.number_type;
      if (numberType === 'guest') {
        tags.push('Guest');
      } else if (numberType === 'homekeeper') {
        tags.push('Pro');
      } else {
        tags.push('Unknown Type');
      }

      const address = this.addressFilter?.find(
        (item) => item.value === chatRoom?.data?.assigned_to?.id
      );
      if (address) {
        tags.push(address?.viewValue);
      }
    }
    if (job) {
      const address = this.addressResponse?.find(
        (item) => item.id === job?.address_id
      );
      const addressName = this.getPropertyName(address);
      tags.push(addressName);
      const jobInfo = this.getJobInfo(job);
      tags.push(jobInfo);
    }
    return tags;
  }

  parseAndSortMessagesByDate(messages) {
    const array: any = [];
    messages.map((message) => {
      message?.chat_rooms?.map((chatRoom) => {
        // The "counterparty" is the guest/pro side of the room:
        // Homekeeper/PhoneNumber on pro chats, Guest on guest/guest_reservation chats.
        const homekeeper = chatRoom.all_chat_room_members.find((item) =>
          isCounterpartyMessage(item)
        );
        if (!homekeeper) { return; }
        homekeeper.chat_room_key = chatRoom?.key;
        const messageCategory = this.getMessageCategory(chatRoom);
        const tags = this.getTags(chatRoom, message?.job, homekeeper);
        const displayName = this.getDisplayName(
          homekeeper,
          message?.job,
          chatRoom
        );
        const parsedDateTime = this.getSmartDateDisplay(chatRoom.last_chat_room_message.sent_at);
        const { parsedDate, lastMessageWasSentLessThan8HoursAgo } =
          this.getRelativeMessageDateTime(
            chatRoom?.last_chat_room_message?.sent_at
          );
        array.push({
          ...message,
          isUnread: chatRoom?.last_chat_room_message?.is_read === false && isCounterpartyMessage(chatRoom?.last_chat_room_message?.from_member),
          chatRoom,
          job: message.job,
          type: message.type,
          message: chatRoom?.last_chat_room_message?.content?.text,
          files: chatRoom?.last_chat_room_message?.content?.files,
          homekeeper,
          relativeDateTime: parsedDate,
          parsedDateTime,
          lastMessageWasSentLessThan8HoursAgo,
          displayName,
          initials: this.getInitials(homekeeper),
          tags,
          messageCategory,
          contactInfo: this.getContactInfo(chatRoom, homekeeper),
        });
      });
    });
    // Ties are broken by chat room key so the 10s refresh can't reshuffle rows sharing a sent_at.
    array.sort((a, b) => {
      const sentAtA = a.chatRoom.last_chat_room_message.sent_at;
      const sentAtB = b.chatRoom.last_chat_room_message.sent_at;
      if (sentAtA !== sentAtB) {
        return sentAtA < sentAtB ? 1 : -1;
      }
      return String(a.chatRoom.key).localeCompare(String(b.chatRoom.key));
    });
    return array;
  }

  private refreshDisplayNames(): void {
    if (!this.messages?.length) {
      return;
    }
    // Re-run once addresses have loaded: the first parse can happen before
    // addresses are ready (demo data resolves instantly while getAddresses is
    // still in flight), so names/tags that depend on the address list are
    // recomputed here now that addressResponse/addressFilter are populated.
    for (const msg of this.messages) {
      msg.displayName = this.getDisplayName(msg.homekeeper, msg.job, msg.chatRoom);
      msg.tags = this.getTags(msg.chatRoom, msg.job, msg.homekeeper);
      msg.contactInfo = this.getContactInfo(msg.chatRoom, msg.homekeeper);
    }
    this.shownMessages = this.messages;
  }

  getInitials(homekeeper: any): string {
    return homekeeper?.first_name?.charAt(0) + homekeeper?.last_name?.charAt(0);
  }

  getSmartDateDisplay(sentAt: string): string {
    if (!sentAt) {
      return '';
    }
    const msgDate = LuxonDateTime.fromISO(sentAt);
    const now = LuxonDateTime.local();
    if (msgDate.hasSame(now, 'day')) {
      return msgDate.toFormat('h:mma').toLowerCase();
    }
    const sixDaysAgo = now.minus({ days: 6 });
    if (msgDate >= sixDaysAgo.startOf('day')) {
      return msgDate.toFormat('cccc');
    }
    if (msgDate.year === now.year) {
      return msgDate.toFormat('MMM d');
    }
    return msgDate.toFormat('MMM d yyyy');
  }

  getDisplayName(homekeeper: any, job?: any, chatRoom?: any): string {
    let displayName = '';
    if (chatRoom.type === 'proxy') {
      const parsedPhoneNumber = chatRoom?.data?.phone_number?.replace(
        /^\+?\d{1,3}(\d{3})(\d{3})(\d{4})$/,
        '($1) $2-$3'
      );
      const contactInfo = this.getContactInfo(chatRoom, homekeeper);
      // Number assigned to a known guest contact: show their name (resolved by id);
      // fall back to the number while the name loads.
      if (contactInfo?.state === 'known' && contactInfo?.category === 'guest') {
        return this.resolveGuestName(contactInfo.guestId) || parsedPhoneNumber;
      }
      // Number assigned to a known pro: show the pro's name (same as guests).
      if (contactInfo?.state === 'known' && contactInfo?.category === 'pro') {
        const assignedProId = chatRoom?.data?.assigned_to?.id;
        const knownPro = this.proList?.find((proItem) => proItem.proId === assignedProId);
        return knownPro?.viewValue || parsedPhoneNumber;
      }
      // Otherwise prefer the assigned pro/property name whenever we have one;
      // only fall back to the bare phone number when there's no name to show.
      const assignedToId = chatRoom?.data?.assigned_to?.id;
      const hasValidAssignedId = typeof assignedToId === 'string' || typeof assignedToId === 'number';
      const pro = hasValidAssignedId ? this.proList.find(
        (proItem) => proItem.value === assignedToId
      ) : undefined;
      const address = hasValidAssignedId ? this.addressFilter?.find(
        (item) => item.value === assignedToId
      ) : undefined;
      // The server resolves the assigned pro's name directly from the assignment,
      // so a pro who was never booked (absent from proList) still renders a name.
      const assignedProName = chatRoom?.data?.assigned_homekeeper?.name;
      const assignedName = pro?.viewValue || address?.viewValue || assignedProName;
      return assignedName || parsedPhoneNumber;
    }
    displayName = `${homekeeper?.first_name} ${homekeeper?.last_name}`;
    if (job) {
      const jobInfo = this.getJobInfo(job);
      const address = this.addressResponse?.find(
        (item) => item.id === job?.address_id
      );
      const addressName = this.getPropertyName(address);
      displayName = `${displayName} for ${jobInfo} @ ${addressName}`;
    }
    return displayName;
  }

  getJobInfo(job: any): string {
    return `${
      job?.state?.charAt(0)?.toUpperCase()?.replace('_', ' ') + job?.state?.slice(1)?.replace('_', ' ')
    } Job`;
  }

  getMessageCategory(chatRoom: any): 'pro' | 'guest' | 'unknown' {
    // Defensive: handle missing chatRoom
    if (!chatRoom) {
      return 'unknown';
    }

    if (chatRoom.type === 'proxy') {
      // Defensive: handle missing data or number_type
      const numberType = chatRoom?.data?.number_type;
      if (numberType === 'guest') {
        return 'guest';
      }
      if (numberType === 'homekeeper') {
        return 'pro';
      }
      // Placeholder: proxy without number_type (backend data incomplete)
      return 'unknown';
    }

    if (chatRoom.type === 'account') {
      return 'pro';
    }

    if (chatRoom.type === 'guest' || chatRoom.type === 'guest_reservation') {
      return 'guest';
    }

    // Placeholder: unrecognized chatRoom type
    return 'unknown';
  }

  private isKnownProId(id: number): boolean {
    return !!this.proList?.some((pro) => pro?.proId === id);
  }

  private isKnownGuestId(id: number): boolean {
    // Until the guest list has loaded, don't downgrade — assume known. The list
    // loads before the first render, so this only avoids a false downgrade if
    // the fetch is slow or fails.
    if (!this.guestsLoaded) {
      return true;
    }
    return this.guestIds.has(id);
  }

  // Single source of truth for the "contact" affordance on a conversation:
  // whether we already know the person (View contact) or not (Add contact),
  // plus the navigation/assignment data each case needs.
  getContactInfo(chatRoom: any, homekeeper?: any): any {
    if (!chatRoom) {
      return null;
    }
    if (chatRoom.type === 'account') {
      return { state: 'known', category: 'pro', linkLabel: 'View Contact', showCategorySuffix: false, proId: homekeeper?.id };
    }
    if (chatRoom.type === 'guest' || chatRoom.type === 'guest_reservation') {
      const guestId = chatRoom?.data?.guest_id ?? homekeeper?.id;
      return { state: 'known', category: 'guest', linkLabel: 'View Contact', showCategorySuffix: false, guestId };
    }
    if (chatRoom.type === 'proxy') {
      const numberType = chatRoom?.data?.number_type;
      const assigned = chatRoom?.data?.assigned_to;
      const phone = chatRoom?.data?.phone_number;
      const chatRoomKey = chatRoom?.key;
      if (numberType === 'guest') {
        // Only "known" when the assigned guest still exists (resolvable in the
        // guest list). A deleted guest drops back to an add-able unknown number.
        if (assigned?.type === 'Guest' && assigned?.id !== null && assigned?.id !== undefined && this.isKnownGuestId(assigned.id)) {
          return { state: 'known', category: 'guest', linkLabel: 'View Contact', showCategorySuffix: false, guestId: assigned.id };
        }
        return { state: 'unknown', category: 'guest', linkLabel: 'Add Guest Contact', showCategorySuffix: true, phone, chatRoomKey };
      }
      if (numberType === 'homekeeper') {
        // Only "known" when the assigned pro is one this customer can actually
        // view (in their pros list). A number assigned to a homekeeper outside
        // the account can't be opened, so treat it as an unknown number to add.
        if (assigned?.type === 'Homekeeper' && assigned?.id !== null && assigned?.id !== undefined && this.isKnownProId(assigned.id)) {
          return { state: 'known', category: 'pro', linkLabel: 'View Contact', showCategorySuffix: false, proId: assigned.id };
        }
        // The server-resolved assigned pro name lets us prefill the Add Pro form.
        const name = chatRoom?.data?.assigned_homekeeper?.name;
        // When we already know the pro's name we render it instead of the bare
        // number, so the "(pro)" suffix would be redundant — only show it when
        // the card falls back to displaying the phone number.
        return { state: 'unknown', category: 'pro', linkLabel: 'Add Pro Contact', showCategorySuffix: !name, phone, chatRoomKey, name };
      }
    }
    return null;
  }

  onContactAction(message: any): void {
    if (this.demoBlock.block()) { return; }
    const info = message?.contactInfo;
    if (!info) { return; }
    if (info.state === 'known' && info.category === 'pro' && info.proId !== null && info.proId !== undefined) {
      this.goToPage(`my-pro/${info.proId}`, { proId: info.proId }, MyProPage);
      return;
    }
    if (info.state === 'known' && info.category === 'guest' && info.guestId !== null && info.guestId !== undefined) {
      this.goToPage('edit-guest', { mode: 'edit', guestId: info.guestId }, EditGuestPage);
      return;
    }
    if (info.state === 'unknown' && info.category === 'guest') {
      this.goToPage('edit-guest', { mode: 'create', phone: info.phone, assignToChatRoomKey: info.chatRoomKey, assignType: 'guest' }, EditGuestPage);
      return;
    }
    if (info.state === 'unknown' && info.category === 'pro') {
      this.goToPage('add-pro', { phone: info.phone, name: info.name, noAddressSelected: true, assignToChatRoomKey: info.chatRoomKey, assignType: 'homekeeper' }, AddProPage);
    }
  }

  private resolveGuestName(guestId: number): string | undefined {
    if (guestId === null || guestId === undefined) {
      return undefined;
    }
    const cached = this.guestNameCache.get(guestId);
    if (cached) {
      return cached;
    }
    void this.ensureGuestsLoaded();
    return undefined;
  }

  // Resolve guest names from a single list fetch (like pros resolve from one
  // cached getAllPros() call) instead of pinging /guests/:id per guest. Loaded
  // once and cached, so a missing/deleted assigned guest simply falls back to
  // the number without re-pinging on every refresh.
  private async ensureGuestsLoaded(force = false): Promise<void> {
    if (this.guestsLoading || (this.guestsLoaded && !force)) {
      return;
    }
    this.guestsLoading = true;
    try {
      const page = await lastValueFrom(this.guestsApi.listGuests({ page: 1, perPage: 500 }));
      // Rebuild both the existence set and the name map so deletions/additions
      // are reflected (this only runs on first load or a forced refresh).
      this.guestIds = new Set<number>();
      this.guestNameCache = new Map<number, string>();
      (page?.guests ?? []).forEach((guest) => {
        if (guest?.id === null || guest?.id === undefined) {
          return;
        }
        this.guestIds.add(guest.id);
        const name = (guest.name || '').trim();
        if (name) {
          this.guestNameCache.set(guest.id, name);
        }
      });
      this.guestsLoaded = true;
      this.refreshGuestDisplayNames();
    } catch (_err) {
      // Leave existing data / number fallback; a later attempt can retry.
    } finally {
      this.guestsLoading = false;
    }
  }

  // Once the guest list is known, recompute contact state + display name for
  // each conversation: a guest that no longer exists (e.g. deleted) drops back
  // to an "Add Guest Contact" unknown state, and resolvable guests show a name.
  private refreshGuestDisplayNames(): void {
    const apply = (arr: any[]) => arr?.forEach((m) => {
      if (m?.chatRoom) {
        m.contactInfo = this.getContactInfo(m.chatRoom, m.homekeeper);
        m.displayName = this.getDisplayName(m.homekeeper, m.job, m.chatRoom);
      }
    });
    apply(this.messages);
    apply(this.shownMessages);
    apply(this.imutableMessages);
  }

  getPropertyName(address: any): string {
    if (address?.address_name) {
      return address.address_name;
    }

    if (address?.address2 && address?.address2 !== '') {
      return `${address.address1}, ${address.address2}`;
    }

    return address?.address1;
  }

  initAssignmentState(): void {
    if (this.selectedConversation?.chatRoom?.type !== 'proxy') {
      this.showAssignDropdown = false;
      this.assignedToId = null;
      this.assignList = [];
      this.isGuestNumber = false;
      return;
    }
    const numberType = this.selectedConversation?.chatRoom?.data?.number_type;
    this.isGuestNumber = numberType === 'guest';
    const rawAssignedToId = this.selectedConversation?.chatRoom?.data?.assigned_to?.id;
    this.assignedToId = typeof rawAssignedToId === 'number' ? rawAssignedToId : null;
    if (this.isGuestNumber) {
      this.assignList = this.addressFilter || [];
    } else {
      this.assignList = this.getFilteredProListWithoutProxyNumbers(this.proList || []);
    }
    this.showAssignDropdown = false;
  }

  getFilteredProListWithoutProxyNumbers(proList: any[]): any[] {
    return proList.filter((pro) => !pro.chatRoomKey);
  }

  toggleAssignDropdown(): void {
    if (this.demoBlock.block()) { return; }
    if (!this.showAssignDropdown) {
      this.originalAssignedToId = this.selectedConversation?.chatRoom?.data?.assigned_to?.id || null;
      this.showAssignDropdown = true;
      if (!this.originalAssignedToId && this.assignList?.length > 0) {
        this.assignedToId = this.assignList[0].value;
      }
    } else {
      this.showAssignDropdown = false;
      this.assignedToId = this.originalAssignedToId;
    }
  }

  getAssignedToViewValue(id: number): string {
    return this.assignList?.find((item) => item?.value === id)?.viewValue || '';
  }

  async saveAssignment(): Promise<void> {
    if (this.demoBlock.block()) { return; }
    if (!this.assignedToId || !this.selectedConversation?.chatRoom?.key) {
      return;
    }
    const loading = await this.util.showLoading();
    try {
      await this.communication.assignChat(
        this.selectedConversation.chatRoom.key,
        this.assignedToId,
        this.isGuestNumber ? 'address' : 'homekeeper'
      );
      this.selectedConversation.chatRoom.data.assigned_to = {
        id: this.assignedToId,
        type: this.isGuestNumber ? 'address' : 'homekeeper'
      };
      this.refreshAssignedDisplayName(this.selectedConversation);
      loading.dismiss();
      this.showAssignDropdown = false;
      this.util.showSuccess('Assignment saved successfully');
    } catch (err) {
      loading.dismiss();
      const errorMessage = err?.error?.message || err?.message || 'Failed to save assignment';
      this.util.showError(errorMessage);
    }
  }

  dontShowClientMessagesAsUnread() {
    this.messages.map((message) => {
      const lastMessage = message.chatRoom.last_chat_room_message;
      if (!isCounterpartyMessage(lastMessage.from_member) && !lastMessage.is_read) {
        lastMessage.is_read = true;
      }
    });
  }

  @Loading('', true)
  async goToMessagesPage(message: any): Promise<void> {
    if (this.showAboutThisPage) {
      return;
    }
    try {
      this.markMessagesAsRead(message);
      if (this.windowService.isDesktopRes) {
        this.selectedConversation = message;
        this.initAssignmentState();
        await this.loadThreadMessages(message);
        this.startUnifiedRefreshTimer();
      } else {
        await this.storage.delete('chatRoomKey');
        const roomType = message.chatRoom?.type;
        // Proxy smart-numbers and guest rooms are addressed by their chat room
        // key, not a pro id. Their `homekeeper` is not a real pro (guest rooms
        // carry a non-pro id, proxy rooms none), so persisting it as `proId`
        // would send the thread page to an arbitrary pro or a NaN address URL.
        const isKeyedRoom = roomType === 'proxy' || roomType === 'guest' || roomType === 'guest_reservation';
        const params: any = { backPage: 'messages' };
        if (isKeyedRoom) {
          await this.storage.delete('proId');
          params.chatRoomKey = message.chatRoom.key;
          params.pageTitle = message.displayName;
        } else {
          await this.storage.save('proId', message.homekeeper.id);
          params.proId = message.homekeeper.id;
        }
        params.contactInfo = message.contactInfo;
        this.goToPage(
          'message-thread',
          params,
          MessageThreadPage
        );
      }
    } catch (err) {
      this.errorMessage = err.error ? err.error.message : err.message;
    }
  }

  async markMessagesAsRead(message: any) {
    if (message.isUnread && message?.chatRoom?.key) {
      this.communication.markMessagesAsRead([message?.chatRoom?.key]);
      message.isUnread = false;
      message.chatRoom.last_chat_room_message.is_read = true;
      const updateMessageInArray = (array: any[]) => {
        const index = array.findIndex(msg => msg?.chatRoom?.key === message?.chatRoom?.key);
        if (index !== -1) {
          array[index] = { ...message };
        }
      };
      updateMessageInArray(this.messages);
      updateMessageInArray(this.shownMessages);
      updateMessageInArray(this.imutableMessages);
    }
  }

  getRelativeMessageDateTime(date: string): {
    parsedDate: string;
    lastMessageWasSentLessThan8HoursAgo: boolean;
  } {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const relativeDate = LuxonDateTime.fromISO(date)
      .setZone(timezone)
      .toRelative();
    const lastMessageWasSentLessThan8HoursAgo =
      LuxonDateTime.fromISO(date).setZone(timezone).diffNow('hours').hours < -8;
    if (
      relativeDate.includes('day') ||
      relativeDate.includes('month') ||
      relativeDate.includes('year')
    ) {
      const parsedDate = `${new ParseDateTimePipe().transform(date, 'ddd MMM d')  } ${  new ParseDateTimePipe().transform(date, 'h:mma')}`;
      return { parsedDate, lastMessageWasSentLessThan8HoursAgo };
    } else {
      return { parsedDate: relativeDate, lastMessageWasSentLessThan8HoursAgo };
    }
  }

  getProName(message) {
    const pro = message.chatRoom.all_chat_room_members.find(
      (item) => item.type === 'Homekeeper'
    );
    return pro?.first_name;
  }

  onFilterValueChange(event: number[], type: string): void {
    if (this.showAboutThisPage) {
      return;
    }
    if (type === 'pro') {
      this.selectedPros = event;
    } else {
      this.selectedAddresses = event;
    }
    this.filterRows();
    if (this.searchForm.value.search) {
      this.updateSearch({search: this.searchForm.value.search});
    }
  }

  filterRows() {
    this.messages = this.imutableMessages.filter((message) => {
      const pro = message.homekeeper;
      const address = message?.job?.address_id || message?.chatRoom?.data?.assigned_to?.id;
      const proFilterPassed = this.selectedPros?.length
        ? this.selectedPros.includes(pro.id) || this.selectedPros.includes(pro?.chat_room_key) || this.selectedPros.includes(message?.chatRoom?.data?.assigned_to?.id)
        : true;
      const addressFilterPassed = this.selectedAddresses?.length
        ? this.selectedAddresses.includes(address)
        : true;
      // Defensive: handle missing messageCategory (fallback to 'unknown')
      const category = message.messageCategory || 'unknown';
      const messageTypeFilterPassed = this.selectedMessageType !== 'all'
        ? category === this.selectedMessageType
        : true;
      return proFilterPassed && addressFilterPassed && messageTypeFilterPassed;
    });
    this.shownMessages = this.messages;

  }

  getEmptyStateMessage(): string {
    if (this.selectedMessageType === 'pro') {
      return 'No pro messages found. Try selecting "All Messages" or "Guest Messages".';
    }
    if (this.selectedMessageType === 'guest') {
      return 'No guest messages found. Try selecting "All Messages" or "Pro Messages".';
    }
    if (this.searchForm?.value?.search) {
      return `No messages found for "${this.searchForm.value.search}". Try a different search term or clear your filters.`;
    }
    if (this.selectedPros?.length || this.selectedAddresses?.length) {
      return 'No messages match your current filters. Try clearing some filters.';
    }
    return 'No messages yet. Start a conversation by clicking the button above.';
  }

  clearAllFilters(): void {
    this.selectedMessageType = 'all';
    this.selectedPros = [];
    this.selectedAddresses = [];
    this.chips = [];
    this.searchForm.patchValue({ search: '' });
    this.filterRows();
  }

  async goToNewMessagePage(shouldDeleteKeys = true): Promise<void> {
    if (this.showAboutThisPage) {
      return;
    }
    if (shouldDeleteKeys) {
      await this.storage.delete('proId');
      await this.storage.delete('chatRoomKey');
      await this.storage.delete('dialog-params');
    }
    this.goToPage('new-message', {}, NewMessagePage);
  }

  toggleNewMessageDropdown(): void {
    this.showNewMessageDropdown = !this.showNewMessageDropdown;
  }

  async goToNewGuestMessage(): Promise<void> {
    this.showNewMessageDropdown = false;
    if (this.showAboutThisPage) {
      return;
    }
    await this.storage.delete('proId');
    await this.storage.delete('chatRoomKey');
    await this.storage.delete('dialog-params');
    this.goToPage('new-message', { messageMode: 'guest' }, NewMessagePage);
  }

  async selectProForNewMessage(pro: any): Promise<void> {
    this.showNewMessageDropdown = false;
    if (!pro?.chatRoomKey) {
      const proxyConversation = this.findProxyConversationForTeam(pro?.teamId);
      if (proxyConversation) {
        await this.goToMessagesPage(proxyConversation);
        return;
      }
    }
    await this.createAndSelectNewConversation(pro);
  }

  private refreshAssignedDisplayName(conversation: any): void {
    if (!conversation?.chatRoom) {
      return;
    }
    conversation.displayName = this.getDisplayName(conversation.homekeeper, conversation.job, conversation.chatRoom);
  }

  goToContactsPage(): void {
    this.showNewMessageDropdown = false;
    this.navCtrl.navigateForward('contacts');
  }

  async openAddProxyNumberModal(type: string): Promise<void> {
    if (this.demoBlock.block()) { return; }
    const params = {
      type,
      number: type === 'pro' ? this.proNumber : this.guestNumber,
    };

    const subscriptions = await this.subscriptionsQueries.getSubscriptions();
    const currentSubscription = this.me.getCurrentSubscription(subscriptions);
    const hasAutopilot = currentSubscription?.plan?.key?.includes('full-autopilot');
    if (!hasAutopilot) {
      await this.storage.save('autopilot-pending-step', {
        route: 'add-number',
        title: 'Add Number',
        params
      });
      this.rightSidePanelService.setDialogPageTitle('Enable Autopilot');
      await this.rightSidePanelService.navigateTo('go-live/enable-autopilot', {}, EnableAutopilotComponent);
      return;
    }

    this.goToPage('add-number', params, AddProxyNumberComponent);
  }

  async patchProxyNumber(): Promise<void> {
    const createdNumber = await this.storage.retrieve('created-number');
    if (createdNumber) {
      if (createdNumber.type === 'homekeeper') {
        this.proNumber = createdNumber.number;
      } else {
        this.guestNumber = createdNumber.number;
      }
    }
  }

  async reloadMessages(): Promise<void> {
    this.showLoadingSpinner = true;
    try {
      this.proList = [];
      this.proxyPros = [];
      this.allPros = [];
      await this.getProxyNumbers();
      if (this.filters && Object.keys(this.filters).length !== 0) {
        await this.loadMessages(this.filters);
      } else {
        await this.loadMessages();
      }
      this.filterRows();
      if (this.searchForm.value.search) {
        this.updateSearch({search: this.searchForm.value.search});
      }
    } catch (error) {
      this.util.showError(error.error ? error.error.message : error.message);
    } finally {
      this.showLoadingSpinner = false;
    }
  }

  // After a panel-driven reload rebuilds the messages array, re-point the desktop
  // right-panel selection at the fresh conversation object (matched by chat room
  // key) so its header reflects updated data — e.g. a number that was just linked
  // to a contact flips from "Add ... Contact" to "View Contact".
  private reselectSelectedConversation(): void {
    const key = this.selectedConversation?.chatRoom?.key;
    if (!key) {
      return;
    }
    const fresh = this.messages?.find((message: any) => message?.chatRoom?.key === key);
    if (fresh) {
      this.selectedConversation = fresh;
    }
  }

  async loadMessages(filters?: any): Promise<void> {
    try {
      const apiMessages = this.showAboutThisPage ? this.onboardingDummyDataService.getMessagesMockData() : await this.communication.getAllMessages(filters);
      const parsedMessages = this.parseAndSortMessagesByDate(apiMessages);
      this.removeTemporaryConversationsIfRealExists(parsedMessages);
      this.messages = parsedMessages;
      this.appendTemporaryConversations();
      this.shownMessages = this.messages;
      this.imutableMessages = this.messages;
      this.dontShowClientMessagesAsUnread();
      this.isMessagesLoaded = true;
      this.updateLoadingState();
      this.storage.save('messagesPageMessages', this.messages);
    } catch (error) {
      this.errorMessage = error?.error?.message ?? error?.message ?? 'Failed to load messages';
      this.isMessagesLoaded = true;
      this.updateLoadingState();
    }
  }

  removeTemporaryConversationsIfRealExists(apiMessages: any[]): void {
    this.temporaryConversations = this.temporaryConversations.filter(temp => {
      const realExists = apiMessages.some(msg =>
        msg.homekeeper?.id === temp.homekeeper?.id &&
        msg.displayName === temp.displayName
      );
      return !realExists;
    });
  }

  appendTemporaryConversations(): void {
    this.temporaryConversations.forEach(temp => {
      if (!this.messages.some(msg => msg.tempId === temp.tempId)) {
        this.messages.push(temp);
      }
    });
  }

  async goToPage(url, params, component) {
    if (this.showAboutThisPage) {
      return;
    }
    const isDesktopRes = this.windowService.isDesktopRes;
    if (isDesktopRes) {
      const isRightSidePanelAlreadyOpen = await this.storage.retrieve('dialog-right-side-open');
      if (isRightSidePanelAlreadyOpen) {
        this.rightSidePanelService.navigateTo(url, params, component);
      } else {
        this.storage.save('dialog-right-side-open', true);
        this.storage.save('dialog-params', params);
        this.rightSidePanelService.openRightSidePanel(component);
      }
      this.rightSidePanelService.panelClosed().pipe(take(1), takeUntilDestroyed(this.destroyRef)).subscribe(async () => {
        this.storage.delete('proId');
        this.storage.delete('chatRoomKey');
        await this.handleNewMessageSelection();
        await this.ensureGuestsLoaded(true);
        await this.reloadMessages();
        this.reselectSelectedConversation();
      });
    } else {
      this.navCtrl.navigateForward(url, params);
    }
  }

  hasChild = (_: number, node: FlatNode) => node.expandable;

  getTreeData(): void {
    const treeData = [
      {
        name: 'Person',
        children: this.proList.map(pro => ({
          name: pro.viewValue,
          value: pro.value,
          checked: false,
          parentId: 0
        }))
      }
    ];
    treeData.forEach((parent, index) => {
      if (parent.children?.length === 0) {
        treeData.splice(index, 1);
      }
      parent.children?.forEach((child) => {
        child.parentId = index;
      });
    });
    this.dataSource.data = treeData;
  }

  checkNode(node: ItemNode, event: MatCheckboxChange): void {
    node.checked = event.checked;
    this.updateFilters(node, event.checked);
  }

  getNodeVariables(node: ItemNode) {
    const foundParentName = this.dataSource.data[node.data.parentId].name;
    const foundNodeValue = this.dataSource.data[
      node.data.parentId
    ].children.find((child) => child.name === node.name).value;
    const matchedParentName = this.filterNamesReferences[foundParentName];
    return { foundParentName, foundNodeValue, matchedParentName };
  }

  updateFilters(node: ItemNode, isEnabled: boolean): void {
    if (!this.dataSource?.data?.[node?.data?.parentId]?.name) {
      return;
    }
    const { foundParentName, foundNodeValue, matchedParentName } =
      this.getNodeVariables(node);
    const chip: ChipFilter = {
      displayParentName: foundParentName,
      parentName: matchedParentName,
      name: node.name,
      value: foundNodeValue,
      icon: this.getChipIcon(matchedParentName),
      color: this.getChipColor(matchedParentName, foundNodeValue),
    };
    if (isEnabled) {
      this.addChip(chip);
    } else {
      this.removeChip(chip);
    }
  }

  private getChipIcon(parentName: string): string {
    switch (parentName) {
      case 'propertyName':
        return 'home';
      case 'pro':
        return 'person';
      default:
        return '';
    }
  }

  private getChipColor(parentName: string, value: any): string {
    if (parentName === 'propertyName') {
      const address = this.addressResponse?.find((a) => a.id === value);
      return address?.color || '#1E2125';
    }
    return '';
  }

  addChip(chip: ChipFilter): void {
    if (!this.selectedFilters) {
      this.selectedFilters = {
        pro: [],
        propertyName: []
      };
    }
    this.selectedFilters[chip.parentName].push(chip.value);
    this.chips.push(chip);

    if (chip.parentName === 'pro') {
      this.selectedPros = this.selectedFilters.pro;
    } else if (chip.parentName === 'propertyName') {
      this.selectedAddresses = this.selectedFilters.propertyName;
    }

    this.filterRows();
    if (this.searchForm.value.search) {
      this.updateSearch({search: this.searchForm.value.search});
    }
    this.updateTree();
  }

  updateTree(): void {
    this.dataSource.data.forEach((parent) => {
      parent.children.forEach((child) => {
        if (
          this.selectedFilters[
            this.filterNamesReferences[parent.name]
          ]?.includes(child.value)
        ) {
          child.checked = true;
        } else {
          child.checked = false;
        }
      });
    });
  }

  removeChip(chip: ChipFilter): void {
    this.selectedFilters[chip.parentName] = this.selectedFilters[
      chip.parentName
    ].filter((value) => value !== chip.value);
    this.chips = this.chips.filter(
      (item) => item.value !== chip.value
    );

    if (chip.parentName === 'pro') {
      this.selectedPros = this.selectedFilters.pro;
    } else if (chip.parentName === 'propertyName') {
      this.selectedAddresses = this.selectedFilters.propertyName;
    }

    this.filterRows();
    if (this.searchForm.value.search) {
      this.updateSearch({search: this.searchForm.value.search});
    }
    this.updateTree();
  }

  getNodeChecked(node: ItemNode): boolean {
    if (!this.dataSource?.data?.[node?.data?.parentId]?.name) {
      return;
    }
    const { foundParentName, foundNodeValue, matchedParentName } = this.getNodeVariables(node);
    return this.selectedFilters?.[matchedParentName]?.includes(foundNodeValue);
  }

  exportCSV() {
    if (this.showAboutThisPage) {
      return;
    }
    if (this.tidyTable) {
      this.tidyTable.exportCsv(this.tidyTable.tabledataSource);
    } else {
      this.util.showError('No data to export', 5000);
    }
  }

  async loadThreadMessages(message: any): Promise<void> {
    this.isThreadLoaded = false;
    this.threadMessages = [];
    // A file picked in one room must not ride along to the next one, which may
    // be a text-only platform guest room.
    this.threadAttachmentPreviews = [];
    this.threadPro = message.homekeeper;
    this.threadPageNumber = 1;
    this.totalThreadMessages = 0;
    if (message?.isTemporary && this.threadPro?.isGuest && !message?.chatRoom?.key) {
      this.isThreadLoaded = true;
      setTimeout(() => this.threadMessageInput?.focusInput(), 100);
      return;
    }
    try {
      let messagesResponse: { body: any[]; totalRecords: string };
      if (message.chatRoom.type === 'proxy' || !this.threadPro?.main_team_id) {
        messagesResponse = await this.communication.getProxySharedInbox(message.chatRoom.key, 1, 50, true);
      } else {
        messagesResponse = await this.communication.getSharedInbox(this.threadPro.main_team_id, 1, 50);
      }
      this.threadMessages = messagesResponse?.body || [];
      this.totalThreadMessages = parseInt(messagesResponse?.totalRecords || '0', 10);
      this.isThreadLoaded = true;
      this.shouldScrollToBottom = true;
      setTimeout(() => this.threadMessageInput?.focusInput(), 100);
    } catch (err) {
      this.isThreadLoaded = true;
      if (!this.isAuthError(err)) {
        this.util.showError(err?.error?.message || err?.message || 'Error loading messages');
      }
    }
  }

  onChatSuggestionPerformed(suggestion: any): void {
    const index = this.threadMessages.findIndex(msg =>
      msg.content?.chat_suggestion?.id === suggestion.content?.chat_suggestion?.id
    );
    if (index !== -1) {
      this.threadMessages[index].content.chat_suggestion.status = 'performed';
    }
    this.refreshThreadMessagesOnly();
  }

  onChatSuggestionDismissed(suggestion: any): void {
    const index = this.threadMessages.findIndex(msg =>
      msg.content?.chat_suggestion?.id === suggestion.content?.chat_suggestion?.id
    );
    if (index !== -1) {
      this.threadMessages[index].content.chat_suggestion.status = 'dismissed';
    }
  }

  getHomekeeperNameForSuggestion(suggestion: any): string {
    const homekeeperId = suggestion?.content?.chat_suggestion?.data?.homekeeper_id || suggestion?.metadata?.homekeeper_id;
    if (!homekeeperId) {
      return '';
    }
    const pro = this.allPros?.find(p => p.id === homekeeperId);
    if (pro) {
      return `${pro.first_name || ''} ${pro.last_name || ''}`.trim();
    }
    if (this.threadPro?.id === homekeeperId) {
      return `${this.threadPro.first_name || ''} ${this.threadPro.last_name || ''}`.trim();
    }
    return '';
  }

  loadMockThreadMessages(): void {
    this.isThreadLoaded = false;
    this.threadMessages = [];
    this.threadPro = this.selectedConversation?.homekeeper;
    this.threadPageNumber = 1;
    this.totalThreadMessages = 0;
    this.threadMessages = this.onboardingDummyDataService.getThreadMessagesMockData();
    this.totalThreadMessages = this.threadMessages.length;
    this.isThreadLoaded = true;
    this.shouldScrollToBottom = true;
  }

  async markThreadMessagesAsRead(message: any): Promise<void> {
    if (message?.chatRoom?.key) {
      await this.communication.markMessagesAsRead([message.chatRoom.key]);
      const updateMessageInArray = (array: any[]) => {
        const index = array?.findIndex(msg => msg?.chatRoom?.key === message?.chatRoom?.key);
        if (index !== -1 && array[index]) {
          array[index].isUnread = false;
          if (array[index].chatRoom?.last_chat_room_message) {
            array[index].chatRoom.last_chat_room_message.is_read = true;
          }
        }
      };
      updateMessageInArray(this.messages);
      updateMessageInArray(this.shownMessages);
      updateMessageInArray(this.imutableMessages);
    }
  }

  // Read-time messages (chat suggestions, inquiries) have no chat-service id,
  // so they key on the record they wrap; a text message and an inquiry may
  // share a numeric id, hence the prefixes.
  trackThreadMessage(_index: number, message: any): string {
    if (message?.type === 'chat_suggestion') {
      return `suggestion_${message.content?.chat_suggestion?.id}`;
    }
    if (message?.type === 'inquiry') {
      return `inquiry_${message.content?.inquiry?.id}`;
    }
    return `message_${message?.id}`;
  }

  // Opens the same inquiry detail the Inquiries list and the Schedule open
  // (ReservationPage in inquiry mode). `dialog-params` is written on both
  // branches because the page reads `isInquiry` from storage only.
  async openInquiry(message: any): Promise<void> {
    const inquiry = message?.content?.inquiry;
    if (!inquiry?.id) {
      return;
    }
    const params = {
      guestReservation: { id: inquiry.id },
      isInquiry: true,
      addressId: inquiry.address_id,
      returnTo: 'messages',
    };
    await this.storage.save('dialog-params', params);
    if (this.windowService.isDesktopRes) {
      await this.storage.save('dialog-right-side-open', true);
      this.rightSidePanelService.setDialogPageTitle('Inquiry');
      // Resolved from the route registry: importing ReservationPage here closes an import cycle through SharedModule and breaks app boot.
      this.rightSidePanelService.openRightSidePanel(this.rightSidePanelService.getComponentFromRoute('reservation'));
    } else {
      this.navCtrl.navigateForward('reservation', params);
    }
  }

  deduplicateThreadMessages(messages: any[]): any[] {
    // Callers pass [fresh, ...cached]. Keeping the cached copy is fine for text, but an
    // inquiry's status changes after a decline or pre-approve, so it keeps the fresh copy.
    const freshInquiries = new Map<string, any>();
    messages.forEach(message => {
      const messageId = this.trackThreadMessage(0, message);
      if (message?.type === 'inquiry' && !freshInquiries.has(messageId)) {
        freshInquiries.set(messageId, message);
      }
    });
    const seenIds = new Set();
    messages = messages.slice().reverse().filter(message => {
      const messageId = this.trackThreadMessage(0, message);
      if (seenIds.has(messageId)) {
        return false;
      }
      seenIds.add(messageId);
      return true;
    }).map(message => freshInquiries.get(this.trackThreadMessage(0, message)) ?? message);
    messages.sort((a, b) => this.compareThreadMessages(a, b));
    return messages;
  }

  // The 10s refresh merges the fresh page into the cached thread in a different order each tick, and
  // Array.sort is stable, so messages sharing a sent_at need an explicit tiebreaker or they flip places.
  private compareThreadMessages(a: any, b: any): number {
    const timeA = this.getThreadMessageTime(a);
    const timeB = this.getThreadMessageTime(b);
    if (timeA !== timeB) {
      return timeA - timeB;
    }
    return this.getThreadMessageSortId(a) - this.getThreadMessageSortId(b);
  }

  private getThreadMessageTime(message: any): number {
    const time = new Date(message?.sent_at).getTime();
    return Number.isNaN(time) ? Number.MAX_SAFE_INTEGER : time;
  }

  private getThreadMessageSortId(message: any): number {
    // The backend lists an inquiry after a message with the same sent_at, and its id is null.
    if (message?.type === 'inquiry') {
      return Number.MAX_SAFE_INTEGER;
    }
    const id = message?.type === 'chat_suggestion'
      ? message?.content?.chat_suggestion?.id ?? message?.id
      : message?.id;
    const numericId = Number(id);
    return Number.isFinite(numericId) ? numericId : 0;
  }

  scrollThreadToBottom(): void {
    if (this.chatMessagesContainer?.nativeElement) {
      const container = this.chatMessagesContainer.nativeElement;
      container.scrollTop = container.scrollHeight;
    }
  }

  onThreadImageLoad(): void {
    if (this.threadPageNumber === 1) {
      this.scrollThreadToBottom();
    }
  }

  onThreadScroll(event: Event): void {
    const container = event.target as HTMLElement;
    if (container.scrollTop < 500 && !this.isLoadingMoreThreadMessages && this.threadMessages.length < this.totalThreadMessages) {
      this.loadMoreThreadMessages();
    }
  }

  async loadMoreThreadMessages(): Promise<void> {
    if (!this.selectedConversation || this.isLoadingMoreThreadMessages) {
      return;
    }
    this.isLoadingMoreThreadMessages = true;
    this.threadPageNumber++;
    const container = this.chatMessagesContainer?.nativeElement;
    const previousScrollHeight = container?.scrollHeight || 0;
    try {
      let messagesResponse: { body: any[]; totalRecords: string };
      if (this.selectedConversation.chatRoom.type === 'proxy' || !this.threadPro?.main_team_id) {
        messagesResponse = await this.communication.getProxySharedInbox(this.selectedConversation.chatRoom.key, this.threadPageNumber, 50, true);
      } else {
        messagesResponse = await this.communication.getSharedInbox(this.threadPro.main_team_id, this.threadPageNumber, 50);
      }
      const olderMessages = messagesResponse?.body || [];
      if (olderMessages.length > 0) {
        const allMessages = [...olderMessages, ...this.threadMessages];
        this.threadMessages = this.deduplicateThreadMessages(allMessages);
        setTimeout(() => {
          if (container) {
            const newScrollHeight = container.scrollHeight;
            container.scrollTop = newScrollHeight - previousScrollHeight;
          }
        }, 0);
      }
    } catch (err) {
      this.threadPageNumber--;
    } finally {
      this.isLoadingMoreThreadMessages = false;
    }
  }

  isLastInGroup(msg: any, index: number): boolean {
    const nextMsg = this.threadMessages[index + 1];
    if (!nextMsg) {
      return true;
    }
    if (nextMsg.from_member?.type !== msg.from_member?.type) {
      return true;
    }
    if (this.shouldShowTimeIndicator(nextMsg, index + 1)) {
      return true;
    }
    return false;
  }

  shouldShowTimeIndicator(msg: any, index: number): boolean {
    if (index === 0) {
      return true;
    }
    const prevMsg = this.threadMessages[index - 1];
    if (!prevMsg?.sent_at || !msg?.sent_at) {
      return false;
    }
    const prevTime = new Date(prevMsg.sent_at).getTime();
    const currTime = new Date(msg.sent_at).getTime();
    const oneHourMs = 60 * 60 * 1000;
    return (currTime - prevTime) > oneHourMs;
  }

  getTimeIndicatorText(msg: any): string {
    if (!msg?.sent_at) {
      return '';
    }
    const msgDate = LuxonDateTime.fromISO(msg.sent_at);
    const now = LuxonDateTime.local();
    const time = msgDate.toFormat('h:mma').toLowerCase();
    if (msgDate.hasSame(now, 'day')) {
      return `Today ${time}`;
    }
    const yesterday = now.minus({ days: 1 });
    if (msgDate.hasSame(yesterday, 'day')) {
      return `Yesterday ${time}`;
    }
    if (msgDate.hasSame(now, 'week')) {
      return `${msgDate.toFormat('cccc')} ${time}`;
    }
    return `${msgDate.toFormat('ccc MMM d')} ${time}`;
  }

  async sendThreadMessage(): Promise<void> {
    if (this.demoBlock.block()) { return; }
    if (!this.selectedConversation) {
      return;
    }
    if (this.threadMessageForm.get('message').value === '' && this.threadAttachmentPreviews.length === 0) {
      this.util.showWarning('Please add a message or attachment to continue.');
      return;
    }
    this.isSendingThreadMessage = true;
    const payload: any = {
      message: {
        text: this.threadMessageForm.value.message,
        files: this.threadAttachmentPreviews.map(a => a.url),
      },
    };
    if (this.selectedConversation?.chatRoom?.key) {
      payload['to_chat_room_key'] = this.selectedConversation.chatRoom.key;
    } else if (this.threadPro?.isGuest && this.threadPro?.guestId) {
      payload['to_guest_id'] = this.threadPro.guestId;
      payload['includes'] = 'chat_room_key';
    } else if (this.threadPro?.id) {
      payload['to_homekeeper_id'] = this.threadPro.id;
    }
    try {
      const response = await this.communication.sendSharedInboxMessage(payload);
      if (response?.data?.message === "We couldn't send your message, please try again later!") {
        this.util.showError(`Error sending message: ${response.data.message}`);
        this.isSendingThreadMessage = false;
        return;
      }
      this.adoptGuestChatRoomKey(response);
      this.threadMessages.push(response);
      this.threadMessageForm.get('message').reset();
      this.threadAttachmentPreviews = [];
      this.communication.setUpdateMessages();
      setTimeout(() => this.scrollThreadToBottom(), 100);
    } catch (err) {
      if (!this.isAuthError(err)) {
        this.util.showError(`Error sending message: ${err?.error?.message || err?.message}`);
      }
    }
    this.isSendingThreadMessage = false;
  }

  async sendThreadAttachment(): Promise<void> {
    if (this.demoBlock.block()) { return; }
    try {
      const attachment = await this.communication.addAttachment();
      if (!attachment?.url) {
        this.util.showError('Unable to attach file. Please try again.');
        return;
      }
      this.threadAttachmentPreviews.push(attachment);
    } catch (err) {
      if (!this.isAuthError(err)) {
        this.util.showError(err?.error?.message || err?.message);
      }
    }
  }

  removeThreadAttachment(index: number): void {
    this.threadAttachmentPreviews.splice(index, 1);
  }

  openFile(url: string): void {
    window.open(url, '_blank');
  }

  downloadFile = async (url: string): Promise<void> => {
    try {
      const response = await fetch(url);
      const contentType = (response.headers.get('content-type') || '').split(';')[0].trim();
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      const pathname = new URL(url).pathname;
      let filename = decodeURIComponent(pathname.split('/').pop() || 'download');
      if (!filename.includes('.')) {
        const ext = this.getExtensionFromMimeType(contentType)
          || this.getExtensionFromMimeType(blob.type)
          || (this.looksLikeImageUrl(url) ? '.jpg' : '');
        if (ext) {
          filename += ext;
        }
      }
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
    } catch {
      window.open(url, '_blank');
    }
  }

  private getExtensionFromMimeType(mime: string): string {
    if (!mime || mime === 'application/octet-stream') {return '';}
    if (mime.startsWith('image/')) {
      const sub = mime.split('/')[1];
      return sub === 'jpeg' ? '.jpg' : sub === 'svg+xml' ? '.svg' : `.${sub}`;
    }
    const map: Record<string, string> = {
      'application/pdf': '.pdf',
      'text/csv': '.csv',
      'text/plain': '.txt',
    };
    return map[mime] || '';
  }

  private looksLikeImageUrl(url: string): boolean {
    return url.includes('/Media/ME') || url.includes('message-thread-photo/');
  }

  async handleNewMessageSelection(): Promise<void> {
    const selectConversation = await this.storage.retrieve('selectConversationOnMessages');
    const newMessagePro = await this.storage.retrieve('newMessagePro');
    const newMessageGuest = await this.storage.retrieve('newMessageGuest');
    await this.storage.delete('selectConversationOnMessages');
    await this.storage.delete('newMessagePro');
    await this.storage.delete('newMessageGuest');
    if (selectConversation && this.windowService.isDesktopRes) {
      await this.goToMessagesPage(selectConversation);
    } else if (newMessagePro && this.windowService.isDesktopRes) {
      await this.createAndSelectNewConversation(newMessagePro);
    } else if (newMessageGuest && this.windowService.isDesktopRes) {
      await this.createAndSelectNewGuestConversation(newMessageGuest);
    }
  }

  proxyRoomMatchesTeam(chatRoom: any, teamId: number): boolean {
    return chatRoom?.data?.team_id === teamId
      || (typeof chatRoom?.key === 'string' && chatRoom.key.includes(`team_id-${teamId}`));
  }

  findProxyConversationForTeam(teamId: number): any {
    if (!teamId) {
      return null;
    }
    return this.shownMessages?.find(
      (msg: any) => msg?.chatRoom?.type === 'proxy'
        && msg?.chatRoom?.data?.number_type === 'homekeeper'
        && this.proxyRoomMatchesTeam(msg.chatRoom, teamId)
    ) || null;
  }

  async createAndSelectNewConversation(pro: any): Promise<void> {
    const proId = pro.proId;
    const chatRoomKey = pro.chatRoomKey;
    const teamId = pro.teamId;
    const conversation = this.shownMessages?.find((msg: any) => {
      if (chatRoomKey) {
        return msg.chatRoom?.key === chatRoomKey || msg.homekeeper?.chat_room_key === chatRoomKey;
      }
      return msg.homekeeper?.id === proId && msg.homekeeper?.main_team_id === teamId;
    });
    if (conversation) {
      await this.goToMessagesPage(conversation);
    } else {
      const fullPro = {
        id: proId,
        chat_room_key: chatRoomKey,
        first_name: pro.viewValue?.split(' ')[0] || '',
        last_name: pro.viewValue?.split(' ').slice(1).join(' ') || '',
        main_team_id: teamId
      };
      const tempId = `temp_${proId}_${Date.now()}`;
      const newConversation = {
        homekeeper: fullPro,
        displayName: pro.viewValue || `${fullPro.first_name || ''} ${fullPro.last_name || ''}`.trim(),
        initials: (fullPro.first_name?.charAt(0) || '') + (fullPro.last_name?.charAt(0) || ''),
        chatRoom: {
          key: chatRoomKey || `customer_account_id-${localStorage.getItem('customer_id')},team_id-${teamId}`,
          type: chatRoomKey ? 'proxy' : 'account',
          last_chat_room_message: { sent_at: new Date().toISOString(), is_read: true, content: { text: '' } },
          all_chat_room_members: []
        },
        tags: [],
        parsedDateTime: '',
        message: '',
        isUnread: false,
        isTemporary: true,
        tempId
      };
      this.temporaryConversations.push(newConversation);
      this.messages.push(newConversation);
      this.shownMessages = this.messages;
      this.imutableMessages = this.messages;
      await this.goToMessagesPage(newConversation);
    }
  }

  async createAndSelectNewGuestConversation(guest: CustomerGuest): Promise<void> {
    const conversation = this.findGuestConversation(guest);
    if (conversation) {
      await this.goToMessagesPage(conversation);
      return;
    }

    const { firstName, lastName } = this.splitGuestName(guest.name);
    const guestMember = {
      id: guest.id,
      type: 'Guest',
      first_name: firstName,
      last_name: lastName,
      phone: guest.phone,
      email: guest.email,
      chat_room_key: guest.chat_room_key,
      isGuest: true,
      guestId: guest.id,
    };
    const tempId = `temp_guest_${guest.id}_${Date.now()}`;
    const newConversation = {
      homekeeper: guestMember,
      displayName: guest.name || 'Guest',
      initials: `${firstName.charAt(0) || ''}${lastName.charAt(0) || ''}`,
      chatRoom: {
        key: guest.chat_room_key || null,
        type: 'guest',
        last_chat_room_message: { sent_at: new Date().toISOString(), is_read: true, content: { text: '' } },
        all_chat_room_members: [guestMember],
      },
      tags: ['Guest'],
      parsedDateTime: '',
      message: '',
      isUnread: false,
      isTemporary: true,
      messageCategory: 'guest',
      tempId,
    };
    this.messages = this.messages || [];
    this.temporaryConversations.push(newConversation);
    this.messages.push(newConversation);
    this.shownMessages = this.messages;
    this.imutableMessages = this.messages;
    await this.goToMessagesPage(newConversation);
  }

  private findGuestConversation(guest: CustomerGuest): any {
    const chatRoomKey = guest.chat_room_key;
    const candidates = [
      ...(this.shownMessages || []),
      ...(this.messages || []),
      ...(this.temporaryConversations || []),
    ];
    return candidates.find((msg: any) => {
      if (chatRoomKey && (msg.chatRoom?.key === chatRoomKey || msg.homekeeper?.chat_room_key === chatRoomKey)) {
        return true;
      }
      return msg.chatRoom?.all_chat_room_members?.some(
        (member: any) => member?.type === 'Guest' && member?.id === guest.id
      );
    }) || null;
  }

  private splitGuestName(name: string | null): { firstName: string; lastName: string } {
    const parts = (name || 'Guest').trim().split(/\s+/);
    return {
      firstName: parts.shift() || 'Guest',
      lastName: parts.join(' '),
    };
  }

  private adoptGuestChatRoomKey(response: any): void {
    if (!this.threadPro?.isGuest || this.selectedConversation?.chatRoom?.key) {
      return;
    }
    const chatRoomKey = response?.chat_room_key || response?.chat_room?.key;
    if (!chatRoomKey) {
      return;
    }
    this.threadPro.chat_room_key = chatRoomKey;
    this.selectedConversation.chatRoom.key = chatRoomKey;
    this.selectedConversation.homekeeper.chat_room_key = chatRoomKey;
  }

  private isAuthError(err: any): boolean {
    const message = err?.error?.message || err?.message || '';
    return message === 'The access token is invalid' || err?.error?.code === 401 || err?.code === 401;
  }

  onMessageThumbClick(message: any, type: 'positive' | 'negative'): void {
    if (this.demoBlock.block()) { return; }
    this.activeFeedbackMessageId = message.id;
    this.activeFeedbackType = type;
    setTimeout(() => {
      const feedbackForm = this.el.nativeElement.querySelector('.concierge-feedback-form');
      feedbackForm?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 250);
  }

  goToConciergeMessageAgent(): void {
    const triggerKey = this.isGuestNumber
      ? 'custom.message_agent.guest_message_received'
      : 'custom.message_agent.pro_message_received';
    if (this.windowService.isDesktopRes) {
      localStorage.setItem('unified_agent_trigger_key', triggerKey);
      this.navCtrl.navigateForward('agent');
    } else {
      this.navCtrl.navigateForward(`agent/triggers/${encodeURIComponent(triggerKey)}`);
    }
  }

  cancelMessageFeedback(): void {
    this.dismissFeedback();
  }

  async submitMessageFeedback(message: any): Promise<void> {
    if (this.demoBlock.block()) { return; }
    const textarea = this.el.nativeElement.querySelector('.concierge-feedback-textarea') as HTMLTextAreaElement;
    const feedbackText = textarea?.value?.trim();
    this.isSubmittingFeedback = true;
    const data: any = {
      action_taken_key: 'chat_room_message_sent',
      action_object_id: message.id,
      feedback_status: this.activeFeedbackType === 'positive' ? 'approved' : 'rejected',
    };
    if (feedbackText) {
      data.feedback_text = feedbackText;
    }
    try {
      await lastValueFrom(this.conciergeApi.submitFeedback(data));
      this.dismissFeedback();
      this.util.showSuccess('Feedback submitted');
    } catch (err: any) {
      this.util.showError(err?.error?.message || err?.message || 'Failed to submit feedback');
    } finally {
      this.isSubmittingFeedback = false;
    }
  }

  private dismissFeedback(): void {
    this.closingFeedbackMessageId = this.activeFeedbackMessageId;
    setTimeout(() => {
      this.activeFeedbackMessageId = null;
      this.closingFeedbackMessageId = null;
    }, 200);
  }

}
